// Iman Ink — Global JavaScript

// Header scroll effect
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

// Mobile menu
const mobileToggle = document.querySelector('.header-mobile-toggle');
const mobileMenu = document.querySelector('.mobile-menu');
const mobileClose = document.querySelector('.mobile-menu-close');
if (mobileToggle && mobileMenu) {
  mobileToggle.addEventListener('click', () => mobileMenu.classList.add('open'));
  if (mobileClose) mobileClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
  mobileMenu.addEventListener('click', (e) => { if (e.target === mobileMenu) mobileMenu.classList.remove('open'); });
}

// Search modal
const searchBtn = document.querySelector('.search-toggle');
const searchModal = document.querySelector('.search-modal');
if (searchBtn && searchModal) {
  searchBtn.addEventListener('click', () => searchModal.classList.add('open'));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') searchModal.classList.remove('open'); });
  searchModal.addEventListener('click', (e) => { if (e.target === searchModal) searchModal.classList.remove('open'); });
}

// Product accordion
document.querySelectorAll('.product-accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.product-accordion-item');
    item.classList.toggle('open');
  });
});

// Cart notification
window.showCartNotification = function(message) {
  const note = document.getElementById('cart-notification');
  if (!note) return;
  note.textContent = message;
  note.classList.add('show');
  setTimeout(() => note.classList.remove('show'), 3000);
};

// Pubsub (simple event bus)
const subscribers = {};
window.subscribe = function(eventName, fn) {
  subscribers[eventName] = subscribers[eventName] || [];
  subscribers[eventName].push(fn);
  return () => { subscribers[eventName] = subscribers[eventName].filter(s => s !== fn); };
};
window.publish = function(eventName, data) {
  (subscribers[eventName] || []).forEach(fn => fn(data));
};
